<template>

    <div class="pagination" v-if="pages > 1">
        <button type="button" class="page-btn" :disabled="page <= 1" @click="go(page - 1)" aria-label="Назад">
            <AppIcon name="chevron-left" class="page-btn-icon"/>
        </button>

        <button
            v-for="item in page_list"
            :key="'p' + item"
            type="button"
            class="page-btn"
            :class="['page-btn--' + (item === page ? 'active' : 'default')]"
            :disabled="item === -1"
            @click="go(item)"
        >
            {{ item === -1 ? '...' : item }}
        </button>

        <button type="button" class="page-btn" :disabled="page >= pages" @click="go(page + 1)" aria-label="Вперёд">
            <AppIcon name="chevron-right" class="page-btn-icon"/>
        </button>

        <span class="page-info">Стр. {{ page }} из {{ pages }}</span>
    </div>

</template>


<script>

import AppIcon from './AppIcon.vue';

export default {
    name: 'PaginationUI',

    components: {
        AppIcon
    },

    props: {
        page: {
            type: Number,
            default: 1
        },
        pages: {
            type: Number,
            default: 1
        }
    },

    computed: {
        page_list() {
            const total = this.pages;
            const current = this.page;
            const result = [];

            if (total <= 7){
                for (let i = 1; i <= total; i++){
                    result.push(i);
                }

                return result;
            }

            result.push(1);

            if (current > 3){
                result.push(-1);
            }

            for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++){
                result.push(i);
            }

            if (current < total - 2){
                result.push(-1);
            }

            result.push(total);

            return result;
        }
    },

    methods: {
        go(target) {
            if (target < 1 || target > this.pages || target === this.page){
                return;
            }

            this.$emit('change', target);
        }
    }
}

</script>


<style scoped>

.pagination{
    display: flex;
    align-items: center;
    gap: 4px;
}

.page-btn{
    display: inline-flex;
    align-items: center;
    justify-content: center;

    min-width: 30px;
    height: 30px;
    padding: 0 6px;

    background: transparent;
    border: 1px solid transparent;
    border-radius: 8px;

    font-family: inherit;
    font-size: 13px;
    color: var(--muted-foreground);

    cursor: pointer;

    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.page-btn:hover:not(:disabled){
    background: var(--muted);
    color: var(--foreground);
}

.page-btn:disabled{
    opacity: 0.4;
    cursor: not-allowed;
}

.page-btn--active{
    background: var(--primary);
    color: var(--primary-foreground);
}

.page-btn--active:hover:not(:disabled){
    background: var(--primary);
    color: var(--primary-foreground);
}

.page-btn-icon{
    width: 15px;
    height: 15px;
}

.page-info{
    margin-left: 8px;

    font-size: 12px;
    color: var(--muted-foreground);
}

</style>
